function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file); // Converte para Base64
        reader.onload = () => resolve(reader.result.split(',')[1]); // Remove o prefixo "data:*/*;base64,"
        reader.onerror = error => reject(error);
    });
}

async function convertFileToObject(file) {
    const base64 = await fileToBase64(file);
    return {
        name: file.name,
        type: file.type,
        extension: file.name.split('.').pop(),
        base64
    }
}

const mimeTypes = {
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'html': 'text/html',
    'css': 'text/css',
    'js': 'application/javascript',
    'json': 'application/json',
    'pdf': 'application/pdf'
};

function getMimeType(extension) {
    return mimeTypes[extension.toLowerCase()];
}

function base64ToBlob(base64, type) {
    const byteString = Buffer.from(base64, "base64").toString("binary");
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: getMimeType(type) });
};

function blobToFile(blob, fileName) {
    return new File([blob], fileName, { type: blob.type });
};

function convertBase64ToFile(base64, fileName) {
    const blob = base64ToBlob(base64, fileName.split(".")[1]);
    return blobToFile(blob, fileName);
};


export { convertFileToObject, convertBase64ToFile }
